<template>
  <template v-if="!showFullScreenMessage">
    <!-- <ProgressBar :steps="steps" :activeStep="activeStep" :chooseStep="chooseStep"/> -->
    <GravestoneColumn :activeStep="activeStep" :chooseStep="chooseStep" :setFullScreenMessage="setFullScreenMessage" />
  </template>
  <template v-if="showFullScreenMessage">
    <div v-if="fullScreenMessage == ''" class="order-confirmation-container">
      <h2>Tack för er förfrågan om ny gravsten till oss på Orsa Stenhuggeri.</h2>
      <p>Nu ska ni ha fått bekräftelse på er förfrågan till mailadressen som ni angav.</p>
      <p>Om ni inte fått bekräftelse på er förfrågan på mailadressen ni angav så kolla gärna skräpposten.</p>
    </div>
    <div v-if="fullScreenMessage != ''" class="order-confirmation-container">
      <p class="bold">{{ fullScreenMessage }}</p>
    </div>
  </template>
  <div class="eu-container">
    <img style="max-width: 165px;" src="https://crm.orsasten.se/images/EUlogo_v_RGB.jpeg" alt="Europiska unionen logo">
    <p>Projektet har fått stöd från Europeiska unionen.</p>
  </div>
</template>
<script>
// import ProgressBar from './components/ProgressBar.vue'
import GravestoneColumn from './components/GravestoneColumn.vue'

export default {
  name: 'App',
  components: {
    // ProgressBar,
    GravestoneColumn
  },
  data() {
    return {
      activeStep: 0,
      steps: [{
          index: 0,
          title: 'Designa gravsten',
        },
        {
          index: 1,
          title: 'Skicka förfrågan',
        },
        // {
        //   index: 2,
        //   title: 'Skicka förfrågan',
        // }
      ],
      fullScreenMessage: '',
      showFullScreenMessage: false,
      reseller: null
    }
  },
  mounted() {},
  methods: {
    chooseStep(step) {
      if (step >= 0 && step < 3) {
        this.activeStep = step;
      }
    },
    setFullScreenMessage(orderSuccess = true, message = '') {
      this.showFullScreenMessage = true;
      if (!orderSuccess) {
        this.fullScreenMessage = message;
      }
    },

  },
}
</script>
<style>
@font-face {
  font-family: 'FH22-Black';
  src: url('~@/assets/fonts/FH22-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH22-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH15-Black';
  src: url('~@/assets/fonts/FH15-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH15-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH14-Black';
  src: url('~@/assets/fonts/FH14-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH14-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH13-Black';
  src: url('~@/assets/fonts/FH13-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH13-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH12-Black';
  src: url('~@/assets/fonts/FH12-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH12-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH4-Black';
  src: url('~@/assets/fonts/FH4-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH4-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH3-Black';
  src: url('~@/assets/fonts/FH3-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH3-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH2-Black';
  src: url('~@/assets/fonts/FH2-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH2-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'FH1-Black';
  src: url('~@/assets/fonts/FH1-Black.otf') format('font-opentype');
  src: url('~@/assets/fonts/FH1-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.FH22-black {
  font-family: FH22-Black !important;
}

.FH15-black {
  font-family: FH15-Black !important;
}

.FH14-black {
  font-family: FH14-Black !important;
}

.FH13-black {
  font-family: FH13-Black !important;
}

.FH12-black {
  font-family: FH12-Black !important;
}

.FH4-black {
  font-family: FH4-Black !important;
}

.FH3-black {
  font-family: FH3-Black !important;
}

.FH2-black {
  font-family: FH2-Black !important;
}

.FH1-black {
  font-family: FH1-Black !important;
}


h2 {
  margin-bottom: 1rem !important;
  /*font-family: 'FH22-test1-Regular' !important;*/
}

h4 {
  font-weight: bolder !important;
  font-size: 1.4rem !important;
}

h5 {
  font-size: 1.1rem !important;
  color: #444 !important;
  font-weight: bolder !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

p {
  font-size: 1rem !important;
  padding-bottom: 0 !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

a:hover {
  opacity: 0.7;
}

.separator-line {
  height: 0.5rem;
  background: #0c564c;
}

.mt-05 {
  margin-top: 0.5rem;
}

.mt-1 {
  margin-top: 1rem;
}

.mt-2 {
  margin-top: 2rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 1rem;
}

.mb-15 {
  margin-bottom: 1.5rem;
}

.mb-2 {
  margin-bottom: 2rem;
}

.mr-05 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 1rem;
}

.ml-05 {
  margin-left: 0.5rem;
}

.ml-1 {
  margin-left: 1rem;
}

.ml-2 {
  margin-left: 2rem;
}

.pr-2 {
  padding-right: 2rem;
}

.pt-2 {
  padding-top: 2rem;
}

.pt-3 {
  padding-top: 3rem;
}

.pb-2 {
  padding-bottom: 2rem;
}

.pa-1 {
  padding: 1rem;
}

.py-05 {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}

.py-2 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-2 {
  padding-bottom: 2rem;
  padding-top: 2rem;
}

.pa-05 {
  padding: 0.5rem;
}

.font-size-085 {
  font-size: 0.85rem;
}

.font-size-1 {
  font-size: 1rem;
}

.font-size-2 {
  font-size: 2rem;
}

.font-italic {
  font-style: italic;
}

.text-red {
  color: red;
}

.bold {
  font-weight: bolder;
}

.border-light {
  border: 1px solid #c3d2d047;
}

.border-grey {
  border: 1px solid #ddd;
}

.d-flex {
  display: flex;
  width: 100%;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
  height: fit-content;
}

.w-auto {
  width: auto;
}

.shadow-box {
  border-radius: 5px;
  box-shadow: 0 2px 10px 2px rgb(0 0 0 / 10%);
  border: 1px solid #dddddd;
}

.text-center {
  text-align: center;
}

.text-center-important {
  text-align: center !important;
}

.text-left-important {
  text-align: left !important;
}

.text-right-important {
  text-align: right !important;
}

.between {
  justify-content: space-between;
}

.flex-center-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}



.button-large,
.button-xlarge,
.button-small-reverse,
.button {

  text-align: center;
  width: 100%;
  background: #0c564c;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bolder;
  padding: 10px;
  cursor: pointer;
  transition: 0.1s all;
}

.button-small-reverse {
  padding: 0.5rem 1rem;
  width: auto;
  font-size: 1rem;
  background: #fff;
  border: 1px solid #0d564c;
  color: #0d564c;
  min-width: 175px;
  text-align: center;
}

.button-large {
  padding: 20px 10px;
  width: 300px;
}

.button-xlarge {
  padding: 20px 10px;
  width: 100%;

}

.button-large:hover,
.button-xlarge:hover,
.button-small-reverse:hover,
.button:hover {
  opacity: 0.8;
}

.button-large.secondary,
.button.secondary {
  background: #c7c7c7;
  color: #000000;
}

.button-large.disabled,
.button.disabled {
  opacity: 0.2;
}

.bg-light {
  background: #f4f3ee;
}

.wrap {
  flex-wrap: wrap;
}


.d-flex-col {
  display: flex;
  flex-direction: column;
}

.d-flex-col-rev {
  display: flex;
  flex-direction: column-reverse;
}

.d-flex-row-rev {
  display: flex;
  flex-direction: row-reverse;
}

.d-flex-row {
  display: flex;
  flex-direction: row;
}

.conf-col-left {
  /*max-width: 500px;*/
  width: 100%;
  /*background: #f4f3ee;*/
  /*padding: 3rem 2rem;*/
  text-align: left;
}

.conf-col-right {
  width: 100%;
  padding: 2rem 1rem 0 2rem;
  text-align: left;
}

.input-container {
  display: flex;
  flex-direction: column;
}

.order-confirmation-container {
  max-width: 700px;
  margin: 100px auto;
}



.input-container label,
.input-container input,
.input-container input[type=text],
.input-container input[type=email],
.input-container input[type=tel],
.input-container textarea {
  font-size: 16px;
  color: #000;
}

.input-container input,
.input-container input[type=text],
.input-container input[type=email],
.input-container input[type=tel],
.input-container textarea {
  padding: 5px 7.5px;
  border: 1px solid #a5a5a5;
}

.input-container textarea {
  min-height: 120px;
}

.design-choice .input-container textarea {
  min-height: 80px;
}

.input-split-container {
  display: flex;
  justify-content: space-between;
}

.input-split-container .input-container {
  width: 48.5%;
}

.input-warning {
  color: red;
  display: none;
}

.input-warning.active {
  display: block;
}

.h-100 {
  height: 100%;
}


.eu-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 15px;
    padding: 0 2rem;
    margin-top: 25px;
   /* margin-bottom: -10px;
    border-top: 2px solid #f4f3eede;*/
}

.eu-container img {
    background: #fff;
    padding: 5px;
    padding-left: 0;
}

.eu-container p {
    font-style: italic;
    font-weight: 500;
    color: #555;
    font-size: 14px !important;
}

@media only screen and (max-width: 1024px) {
  .w-50 {
    width: 100%;
  }

  .col-container.d-flex {
    flex-direction: column;
  }

  .w-50.ml-1,
  .w-50.mr-1 {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 1rem;
  }
}

@media only screen and (max-width: 1160px) {
  .gravestone-column-container {
    flex-direction: column;
  }
}



@media only screen and (max-width: 600px) {
  .button-small-reverse {
    min-width: auto;
  }

}
</style>